import Image from 'next/image';
import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { toast } from 'react-toastify';
import { actiontype, imageUrls } from '../../../utils/constants';
import PROFILE_URLS from '../../../utils/constants/images/profile';
import { BTN_SIGN_OUT } from '../../../utils/constants/mixpanel';
import {
  copyToClipboardText,
  getAssetProfilePic,
} from '../../../utils/helpers';
import * as Styled from './styles';
import { createMagicInstance } from '../../../utils/wallet/index';
import { ProfileImagePriority } from '../../../graphql/types';
import COMMON_IMAGES from '../../../utils/constants/images/common';
import PolygonImg from '../../../utils/constants/images/SVG/AFKPolygon';
import { useAccount } from 'wagmi';
import { disconnect } from '@wagmi/core';
import { useDeviceDetect } from 'src/hooks/useDeviceDetect';
const magic = createMagicInstance();

const NavbarDropdownButton: React.FC<any> = ({
  account,
  mixpanel,
  dispatch,
  walletManager,
  blockChain,
  imageId,
  afkelephants,
  router,
  showWalletOption,
  setShowOptinModal,
  profilePictureInfo,
  isOptedIn,
  isWithdrawal = false,
}) => {
  const { isConnected } = useAccount();
  const { isMobile } = useDeviceDetect();
  const handleDisconnect = async () => {
    if (isConnected) {
      await disconnect();
    }
    if (localStorage.getItem('walletManagerType') === 'MAGIC') {
      // @ts-ignore:next-line
      await magic.user.logout();
    }
    const visitorId = localStorage.getItem('visitorId');
    mixpanel?.track(BTN_SIGN_OUT, {
      walletAddress: account,
      visitorId,
    });
    await walletManager.disconnect();
    dispatch({ type: actiontype.CLEAR_WALLET });
    if (typeof window !== 'undefined') {
      localStorage.removeItem('visitorId');
      localStorage.removeItem('walletconnect');
      localStorage.removeItem('magicToken');
      localStorage.removeItem('walletManagerType');
      localStorage.removeItem('walletAddress');
      localStorage.removeItem('zone-optin-modal-show');
      localStorage.removeItem('zone-landing-modal-show');
      localStorage.removeItem('isMetaMaskConnected');
      localStorage.clear();
      for (const key in sessionStorage) {
        if (key.substring(0, 11) === '@fpjs@clien') {
          sessionStorage.removeItem(key);
        }
      }
      window.location.replace('/');
    }
  };

  const handleCopyAddress = () => {
    account && copyToClipboardText(account);
    toast.success('Copy successfully');
  };

  const canShowAFK =
    !profilePictureInfo ||
    profilePictureInfo?.profilePriority === ProfileImagePriority.NFT;
  return (
    <>
      <Styled.NavbarDropdownBtn>
        <Dropdown.Toggle id="dropdown-basic">
          <Styled.DropdownWrapper>
            <div className={`wrapper ${canShowAFK ? 'afk-wrapper' : ''}`}>
              {imageId !== -1 && canShowAFK ? (
                <>
                  {' '}
                  <PolygonImg
                    imgSrc={getAssetProfilePic(
                      afkelephants[imageId]?.url || '',
                    )}
                    height={50}
                    width={50}
                    border={true}
                    singleBorder={true}
                    singleBorderStyle={{
                      strokeWidth: '3',
                      stroke: '#6953FF',
                      filter: 'drop-shadow(0 0 1px #6953FF)',
                    }}
                  />
                  <div className="afk-check-wrapper">
                    <Image
                      src={COMMON_IMAGES.AFKCheckPlane}
                      height={12}
                      width={12}
                      alt={'checked'}
                      className={'afk-checked'}
                    />
                  </div>
                </>
              ) : (
                <Styled.ProfilePic>
                  <Image
                    src={profilePictureInfo?.profileUrl || imageUrls.nftDefault}
                    fill
                    alt="zobo icon"
                    quality={100}
                  />
                </Styled.ProfilePic>
              )}
            </div>
            {/* <div className={classEnum.spanOverflowContainer}>
              <span className={`${classEnum.spanOverflow} ignoreWeglot`}>
                {account}
              </span>
            </div> */}
          </Styled.DropdownWrapper>
        </Dropdown.Toggle>
        <Styled.DropDownContent align="end">
          <Styled.DropDownAddrContainer>
            <Styled.DropDownAddr className="ignoreWeglot">
              {account}
            </Styled.DropDownAddr>
            <Styled.DropDownCopyBtn onClick={handleCopyAddress}>
              <Image
                src={imageUrls.copyBtn}
                alt="copy-btn"
                width={12}
                height={14}
              />
              <span>Copy</span>
            </Styled.DropDownCopyBtn>
          </Styled.DropDownAddrContainer>
          <Styled.DropDownSplit />
          {!isWithdrawal && isMobile && (
            <Styled.DropDownCopyBtn
              className="full-btn"
              onClick={() => router.push('/profile')}
            >
              <Styled.ProfileBlock>
                <Image
                  src={imageUrls.profile}
                  alt="profile"
                  width={17}
                  height={17}
                />
                <span>View Profile</span>
              </Styled.ProfileBlock>
              <Image src={imageUrls.arrowRight} alt="lock" />
            </Styled.DropDownCopyBtn>
          )}
          {!isWithdrawal &&
            blockChain !== 'BINANCE' &&
            !(isOptedIn && blockChain === 'ALGORAND') && (
              <Styled.DropDownCopyBtn
                className="full-btn"
                style={{ marginTop: isMobile ? '12px' : '' }}
                onClick={() => setShowOptinModal(true)}
              >
                <div style={{ display: 'flex' }}>
                  <Image src={imageUrls.lockWhite} alt="lock" />
                  <span>&nbsp;Opt-in $ZONE</span>
                </div>
                <Image src={imageUrls.arrowRight} alt="lock" />
              </Styled.DropDownCopyBtn>
            )}

          {showWalletOption && (
            <Styled.DropDownCopyBtn
              className="full-btn"
              style={{ marginTop: '12px' }}
              onClick={() => router.replace('/wallet')}
            >
              <div style={{ display: 'flex' }}>
                <Image
                  height={16}
                  width={16}
                  src={PROFILE_URLS.WalletIcon}
                  alt="wallet_icon"
                />
                <span>Wallet</span>
              </div>
              <Image src={imageUrls.arrowRight} alt="lock" />
            </Styled.DropDownCopyBtn>
          )}
          <Styled.DropDownCopyBtn
            className="full-btn"
            style={{ marginTop: '12px' }}
            onClick={handleDisconnect}
          >
            <div style={{ display: 'flex' }}>
              <Image src={imageUrls.signOut} alt="lock" />
              <span>Sign out</span>
            </div>
            <Image src={imageUrls.arrowRight} alt="lock" />
          </Styled.DropDownCopyBtn>
        </Styled.DropDownContent>
      </Styled.NavbarDropdownBtn>
    </>
  );
};

export default NavbarDropdownButton;
